// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ScrollingText_wrap__3RISV","textSpacer":"ScrollingText_textSpacer__3aA_z","middle_Text":"ScrollingText_middle_Text__1YwDc"};